<ion-header>
  <ion-toolbar color="primary">
      <ion-title>{{ title }}</ion-title>
      <ion-buttons slot="end">
          <ion-button (click)="displayAsModal ? dismiss() : dismissPopover()">
              <ion-icon slot="icon-only" name="close-circle-outline"></ion-icon>
          </ion-button>
      </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid>
    <ng-container *ngIf="!isViewOnly">
      <ion-row>
        <ion-col size='6'>
          <ion-item>
            <ion-label>Uploaded:</ion-label>
            <ion-text>{{ viewImageDoc.uploadedOn | date}}</ion-text>
          </ion-item>
        </ion-col>
        <ion-col style="display: flex; flex-direction: row; align-items: center; justify-content: end;">
          <ion-buttons>
            <ion-button fill="solid" color="warning" (click)="openUploadModal(viewImageDoc)">Upload</ion-button>
          </ion-buttons>
        </ion-col>
      </ion-row>
    </ng-container>
    <ng-container *ngIf="isViewOnly">
      <ion-row *ngIf="allowDownload">
        <ion-col style="display: flex; flex-direction: row; align-items: center; justify-content: end;">
          <ion-buttons>
            <ion-button fill="solid" color="success" (click)="downloadFile()">Download</ion-button>
          </ion-buttons>
        </ion-col>
      </ion-row>
    </ng-container>
    <ion-row>
      <ion-col>
        <ng-container *ngIf="displayMode === 'image'; else pdfViewer">
          <div class="ion-padding">
            <img [src]="safeUrl" style="width: 100%; height: auto;" />
          </div>
        </ng-container>
        <ng-template #pdfViewer>
          <pdf-viewer [src]="stringUrl"
          [rotation]="0"
          [original-size]="false"
          [show-all]="true"
          [fit-to-page]="false"
          [zoom]=".8"
          [stick-to-page]="false"
          [render-text]="true"
          [external-link-target]="'blank'"
          [autoresize]="true"
          [show-borders]="true"
          style="position: unset; min-height: 400px;"></pdf-viewer>
        </ng-template>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>    